import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Experience Entity => experiences => ');

const fetch = createAction('fetch account templates');
const fetchSuccess = createAction('successfully fetched account templates', (accountTemplates, lastQuery) => ({
  accountTemplates,
  lastQuery,
}));
const fetchFailure = createApiFailureAction('failed to fetch account templates', error => ({ error }));

export default {
  fetch,
  fetchSuccess,
  fetchFailure,
};
